import React, { useState } from 'react';
import { HStack } from '@chakra-ui/react';
import { useColors } from '../../../../components/common/Color';
import HeaderSection from '../../../../components/common/Header/HeaderSection';
import GsummaryTable from './GsummaryTable';

function DayBook() {
  const colors = useColors();


  return (
    <div>
      {/* Use the new HeaderSection component */}
      <HeaderSection
        title="Group summary" 
        breadcrumb={["Dashboard", "Accounts", "Group Summary"]} 
      />

      <HStack align="start" w="full"  gap="0" mt={4} p={6}>
        <GsummaryTable colors={colors} />

      </HStack>
    </div>
  );
}

export default DayBook;
